import {
  Icon,
  Label,
  Button,
  Popup,
  Input,
} from "semantic-ui-react";
import { useTextResources } from "../../../../language";
import "./RateCard.less";
import { useState, useEffect } from "react";
import moment from "moment";

const RateCard = ({
  name,
  hotelName,
  isValid,
  dates,
  onNameChange,
  onRateRemove,
}) => {
  const text = useTextResources();
    const [editOpen, setEditOpen] = useState(false);
    const [editValue, setEditValue] = useState(name);
    const [lastSavedName, setLastSavedName] = useState(name);
    
    // Update editValue only when name prop changes from external source (not from our own edit)
    useEffect(() => {
        if (!editOpen && name !== lastSavedName) {
            setEditValue(name);
            setLastSavedName(name);
        }
    }, [name, editOpen, lastSavedName]);

  const onEditStart = () => {
    setEditValue(name);
    setEditOpen(true);
  };

    const onEditDone = () => {
        setEditOpen(false);
        if (editValue !== name && editValue.trim() !== '') {
            setLastSavedName(editValue);
            onNameChange(editValue);
        }
    };

  const onEditCancel = () => {
    setEditOpen(false);
    setEditValue(name);
  };

  return (
    <div className={`rate-card ${!isValid ? "invalid" : ""}`}>
      <Icon name="building outline" size="large" className="rate-card-icon" />

      <div className="rate-card-content">
        <div className="rate-card-header">
          {hotelName}
          {!isValid && (
            <Label size="tiny" basic color="red" className="past-dates-label">
              {text("NameExists")}
            </Label>
          )}
          {moment(dates?.StartDate)?.isBefore(moment().startOf('day')) && (
            <Label size="tiny" basic color="blue" className="past-dates-label">
              {text("PastDates")}
            </Label>
          )}
        </div>
        {editOpen ? (
          <Input fluid>
            <input
              type="text"
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  onEditDone();
                } else if (e.key === 'Escape') {
                  e.preventDefault();
                  onEditCancel();
                }
              }}
              autoFocus
            />
          </Input>
        ) : (
          <div className="rate-card-rate-name" onClick={onEditStart}>
            <span>{name}</span>
          </div>
        )}
        {isValid === false && (
          <div className="rate-card-error">{text("PriceListNameExist")}</div>
        )}
      </div>

      {editOpen ? (
        <>
          <Button
            icon
            basic
            compact
            className="rate-card-action-button"
            onClick={onEditDone}
            disabled={!editValue.trim()}
            aria-label="Save changes"
          >
            <Icon name="check" className="edit-icon" style={{ color: '#21ba45' }} />
          </Button>
          <Button
            icon
            basic
            compact
            className="rate-card-action-button"
            onClick={onEditCancel}
            aria-label="Cancel editing"
          >
            <Icon name="close" className="close-icon" />
          </Button>
        </>
      ) : (
        <>
          <Popup
            content={text("EditRateName")}
            trigger={
              <Button
                icon
                basic
                compact
                className="rate-card-action-button"
                onClick={onEditStart}
                aria-label="Edit rate name"
              >
                <Icon name="edit outline" className="edit-icon" />
              </Button>
            }
          />

          <Popup
            content={text("RemoveRateFromCopyList")}
            trigger={
              <Button
                icon
                basic
                compact
                className="rate-card-action-button"
                onClick={onRateRemove}
              >
                <Icon name="close" className="close-icon" />
              </Button>
            }
          />
        </>
      )}
    </div>
  );
};

export default RateCard;
